import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export function Input({
  className = '',
  label,
  error,
  helperText,
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-214">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-215">
          {label}
        </label>}
      <input id={inputId} className={`flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-216" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-217">{error}</p>}
      {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-218">{helperText}</p>}
    </div>;
}